<div *transloco="let translate;">
    <div class="d-flex justify-content-between align-items-center matDialogBorderBottom">
        <h4 class="matDialogTitle text-[18px] font-bold" mat-dialog-title [textContent]="translate('Select Tenants')"></h4>
        <span class="material-icons mb-1 mt-[-2px]" (click)="closeModal()" mat-dialog-close>close</span>
    </div>
    <hr id="firstLine">
    <hr id="secondLine">
    <mat-dialog-content class="mat-typography subscribeAssetModal matDialogBody">
        <ng-container>
            <perfect-scrollbar class="selectedAssetContainer">
                <div class="selectedAssetsContainer col-12 nopadding" *ngIf='selectedAssetsId.length > 0'>
                    <div class="selectedAssetSection col-12 nopadding" *ngIf="counts.asset > 0">
                        <div class="selectedAssetsTitle col-2 displyInlineBlock nopadding">
                            <span [textContent]="translate('Selected Apps') + ' :'"></span>
                        </div>
                        <div class="selectedAssetsBody col-10 displyInlineBlock nopadding">
                            <mat-chip-set>
                                <ng-container *ngFor="let app of selectedAssets; trackBy: trackById">
                                    <mat-chip *ngIf="app.serviceType === 'ASSET'" class="selectedMatChip" (removed)="removeApp(app)">
                                        <span [textContent]="app.displayName"></span>
                                        <mat-icon matChipRemove class="pointer">cancel</mat-icon>
                                    </mat-chip>
                                </ng-container>
                            </mat-chip-set>
                        </div>
                    </div>
                    <div class="selectedAssetSection col-12 nopadding" *ngIf="counts.bridge > 0">
                        <div class="selectedAssetsTitle col-2 displyInlineBlock nopadding">
                            <span [textContent]="translate('Selected Bridges') + ' :'"></span>
                        </div>
                        <div class="selectedAssetsBody col-10 displyInlineBlock nopadding">
                            <mat-chip-set>
                                <ng-container *ngFor="let app of selectedAssets; trackBy: trackById">
                                    <mat-chip *ngIf="app.serviceType === 'BRIDGE_ASSET'" class="selectedMatChip" (removed)="removeApp(app)">
                                        <span [textContent]="app.displayName"></span>
                                        <mat-icon matChipRemove *ngIf="true" class="pointer">cancel</mat-icon>
                                    </mat-chip>
                                </ng-container>
                            </mat-chip-set>
                        </div>
                    </div>
                    <div class="selectedAssetSection col-12 nopadding" *ngIf="counts.widget > 0">
                        <div class="selectedAssetsTitle col-2 displyInlineBlock nopadding">
                            <span [textContent]="translate('Selected Widgets') + ' :'"></span>
                        </div>
                        <div class="selectedAssetsBody col-10 displyInlineBlock nopadding">
                            <mat-chip-set>
                                <ng-container *ngFor="let app of selectedAssets; trackBy: trackById">
                                    <mat-chip *ngIf="app.serviceType === 'WIDGET'" class="selectedMatChip" (removed)="removeApp(app)">
                                        <span [textContent]="app.displayName"></span>
                                        <mat-icon matChipRemove *ngIf="true" class="pointer">cancel</mat-icon>
                                    </mat-chip>
                                </ng-container>
                            </mat-chip-set>
                        </div>
                    </div>
                    <div class="selectedAssetSection col-12 nopadding" *ngIf="counts.recon > 0">
                        <div class="selectedAssetsTitle col-2 displyInlineBlock nopadding">
                            <span [textContent]="translate('Selected Recons') + ' :'"></span>
                        </div>
                        <div class="selectedAssetsBody col-10 displyInlineBlock nopadding">
                            <mat-chip-set>
                                <ng-container *ngFor="let app of selectedAssets; trackBy: trackById">
                                    <mat-chip *ngIf="app.serviceType === 'RECON'" class="selectedMatChip" (removed)="removeApp(app)">
                                        <span [textContent]="app.displayName"></span>
                                        <mat-icon matChipRemove *ngIf="true" class="pointer">cancel</mat-icon>
                                    </mat-chip>
                                </ng-container>
                            </mat-chip-set>
                        </div>
                    </div>
                    <div class="selectedAssetSection col-12 nopadding" *ngIf="counts.dashbaord > 0">
                        <div class="selectedAssetsTitle col-2 displyInlineBlock nopadding">
                            <span [textContent]="translate('Selected Dashboards') + ' :'"></span>
                        </div>
                        <div class="selectedAssetsBody left-6 col-10 displyInlineBlock nopadding">
                            <mat-chip-set>
                                <ng-container *ngFor="let app of selectedAssets; trackBy: trackById">
                                    <mat-chip *ngIf="app.serviceType === 'DASHBOARD'" class="selectedMatChip" (removed)="removeApp(app)">
                                        <span [textContent]="app.displayName"></span>
                                        <mat-icon matChipRemove *ngIf="true" class="pointer">cancel</mat-icon>
                                    </mat-chip>
                                </ng-container>
                            </mat-chip-set>
                        </div>
                    </div>
                    <div class="selectedAssetSection col-12 nopadding" *ngIf="counts.connector > 0">
                        <div class="selectedAssetsTitle col-2 displyInlineBlock nopadding">
                            <span [textContent]="translate('Selected Connector') + ' :'"></span>
                        </div>
                        <div class="selectedAssetsBody left-6 col-10 displyInlineBlock nopadding">
                            <mat-chip-set>
                                <ng-container *ngFor="let app of selectedAssets; trackBy: trackById">
                                    <mat-chip *ngIf="app.serviceType === 'CONNECTOR'" class="selectedMatChip" (removed)="removeApp(app)">
                                        <span [textContent]="app.displayName"></span>
                                        <mat-icon matChipRemove *ngIf="true" class="pointer">cancel</mat-icon>
                                    </mat-chip>
                                </ng-container>
                            </mat-chip-set>
                        </div>
                    </div>
                    <div class="selectedAssetSection col-12 nopadding" *ngIf="counts.package > 0">
                        <div class="selectedAssetsTitle col-2 displyInlineBlock nopadding">
                            <span [textContent]="translate('Selected Package') + ' :'"></span>
                        </div>
                        <div class="selectedAssetsBody left-6 col-10 displyInlineBlock nopadding">
                            <mat-chip-set>
                                <ng-container *ngFor="let app of selectedAssets; trackBy: trackById">
                                    <mat-chip *ngIf="app.serviceType === 'PACKAGE'" class="selectedMatChip" (removed)="removeApp(app)">
                                        <span [textContent]="app.displayName"></span>
                                        <mat-icon matChipRemove *ngIf="true" class="pointer">cancel</mat-icon>
                                    </mat-chip>
                                </ng-container>
                            </mat-chip-set>
                        </div>
                    </div>
                </div>
                <div class="noAppSelectedClass" *ngIf='selectedAssetsId.length < 1'>
                    <span [textContent]="translate('No App Selected') + '.'"></span>
                </div>
            </perfect-scrollbar>
        </ng-container>
        <div *ngIf="associationAction && selectedAssets.length" class="col-12 orgStructureCnt selectedAppsSeparation">
            <div class="col-6 levelOneOrgs displyInlineBlock verticalAlingTop borderRightForSubscription" (click)="$event.stopPropagation()">
                <p class="section-title" [textContent]="translate('Assign Organization')"></p>
                <perfect-scrollbar class="orgsList assetSubscriptionColumnsHeight h-[31.6vh]">
                    <button mat-menu-item class="eachOrgList hover:!bg-[#0000000a]" (click)="selectOrganization(organization)" [title]="organization.name + ' (' + organization.orgLoginId + ')'" [class.activeOrganization]="organization.name === selectedOrganization.name && organization.id === selectedOrganization.id" *ngFor="let organization of organizationsToRender | FilterPipe: 'name' : filterOrgName : null : 'orgLoginId' | orderBy: 'name'">
                        <span [textContent]="organization.name"></span> <span class="orgId" [textContent]="'(' + organization.orgLoginId + ')'"></span>
                    </button>
                </perfect-scrollbar>
            </div>
            <div class="col-6 orgFlatStructure displyInlineBlock verticalAlingTop" *ngIf="subOrganization?.length">
                <p class="section-title textEllipsis" [textContent]="selectedOrganization.name"></p>
                <mat-form-field class="searchSubOrgs searchInputField w-100 p-0">
                    <input matInput placeholder="Search Sub Organization" type="text" [(ngModel)]="filterSubOrgName">
                    <material-button [buttonType]="'icon'" *ngIf='filterSubOrgName' [color]="'default'" matSuffix [size]="'small'" [suffixIcon]="'close'" (buttonClicked)="filterSubOrgName = ''"></material-button>
                    <material-button [buttonType]="'icon'" *ngIf='!filterSubOrgName' [color]="'default'" matSuffix [size]="'small'" [suffixIcon]="'search'"></material-button>
                </mat-form-field>
                <div class="orgsList assetSubscriptionColumnsHeight h-[25.6vh] overflow-y-auto">
                    <ng-container *ngIf="(subOrganization | FilterPipe: 'displayTenantName' : filterSubOrgName : null : 'orgLoginId' | orderBy: 'displayTenantName') as result">
                        <mat-selection-list #checklist appRemoveAriaOwns>
                            <mat-list-option *ngIf='!filterSubOrgName' [selected]='selectAllFlag' class="childOption" [checkboxPosition]="'before'" title="Select All" (click)="$event.stopPropagation();selectAll(checklist)">
                                <span class="inline-block" [textContent]="translate('Select All')"></span>
                            </mat-list-option>
                            <mat-list-option class="childOption" (click)="checkedChanged(sub.id, checklist)" [checkboxPosition]="'before'" [title]="sub.displayTenantName + ' (' + sub.orgLoginId + ')'" *ngFor="let sub of result" [value]="sub.id">
                                <span class="flex items-center gap-1 min-w-0 w-full overflow-hidden">
                                    <span class="orgName truncate" [textContent]="sub.displayTenantName"></span>
                                    <span class="orgId shrink-0 text-gray-500" [textContent]="'(' + sub.orgLoginId + ')'"></span>
                                </span>
                            </mat-list-option>
                        </mat-selection-list>
                        <label class="noSearchResults top-52" *ngIf="subOrganization.length && !result.length" [textContent]="translate('No organizations matching your search')"></label>
                    </ng-container>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="center" class="matDialogFooter">
        <material-button class='mx-2 noOutline' [text]="translate('Close')" color="default" (buttonClicked)="closeModal()"></material-button>
        <material-button [disabled]='checkForAppSelection() || selectedAssets.length < 1' class='noOutline submitColor' [text]="translate('Subscribe')" color="primary" (buttonClicked)="submitUser()"></material-button>
    </mat-dialog-actions>
</div>
